<template>
  <LoaderFullPage v-if="store.loading" />
  <AgendaListingView v-else-if="store.activeDisplay === DISPLAY_OPTIONS.LIST" />
  <AgendaCalendarView
    v-else-if="store.activeDisplay === DISPLAY_OPTIONS.CALENDAR"
  />
</template>

<script setup>
import AgendaListingView from "@follaw-fr/components/agenda/organisms/AgendaListingView.vue";
import AgendaCalendarView from "@follaw-fr/components/agenda/organisms/AgendaCalendarView.vue";
import { DISPLAY_OPTIONS } from "@follaw-fr/stores/agenda";
import { useAgendaStore } from "@follaw-fr/stores/agenda";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";

const store = useAgendaStore();
</script>
